import React from 'react';
import Highlight from 'react-scale/components/ui/highlight';
import TaskResponseVideo from '../tasks/TaskResponseVideo';

export const instruction = 'Draw a cuboid around vehicles. Predict where occluded.';

export const responseCode = `{
  "annotations": {
    "url": "https://scaleapi-results.s3.us-west-1.amazonaws.com/01f9d6a4-0bab-4ad1-b816-7611526a7fae",
  },
}`;

export const code = `client.createVideoannotationTask(
  {
    callback_url: 'http://www.example.com/callback',
    instruction: '${instruction}',
    attachment_type: 'video',
    attachment: 'http://example.com/video.mp4',
    objects_to_annotate: ['vehicle'],
    min_width: 30,
    min_height: 30,
  },
  (err, task) => {
    // do something with task
  }
);`;

export const response = (
  <div className="data-collection">
    <Highlight className="javascript" key="highlight-json">
      {responseCode}
    </Highlight>
  </div>
);
const annotatedMuxPlaybackID = 'UTyVUcspgaDNKY9rXwvTD3esmaGLq2bs';
const originalMuxPlaybackID = 'LZt02UfoKZU01XlUaxHd00DzkYCmqJww9Iq';

const component = ({ refAsync }) => (
  <TaskResponseVideo
    annotatedMuxPlaybackID={annotatedMuxPlaybackID}
    originalMuxPlaybackID={originalMuxPlaybackID}
    ref={refAsync}
  />
);

export const example = { component };

export const result = null;
